import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const OperatorEnabledDecisioningStudioDimensionPage = lazy(() =>
  import("@scenes/OfferFit/components/DecisioningStudioDimensionPage").then((module) => ({
    default: module.OperatorEnabledDecisioningStudioDimensionPage,
  }))
);

export const offerfitDimensionDetailsNRO: NavigationRoutingObject = {
  Component: OperatorEnabledDecisioningStudioDimensionPage,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "offerfit",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("offerfit-dimension-details-nro-heading", "BrazeAI Decisioning Studio™ Dimension Details"),
  pageNameForTracking: () => "BrazeAI Decisioning Studio™ Dimension Details",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("offerfit-dimension-details-nro-description", "View actions for a BrazeAI Decisioning Studio™ dimension"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    if (!featureOn("offerfit_dashboard") || !featureOn("offerfit_use_case_configuration")) {
      return false;
    }

    const userHasViewDecisioningStudioAgentsPermission = hasPermission("appGroup", {
      permission: "viewDecisioningStudioAgents",
    });

    return isImpersonating || userHasViewDecisioningStudioAgentsPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/decisioning_studio/agents/:appGroupId",
};
